import RequestAcceptedModal from './RequestCompleteModal';

export default RequestAcceptedModal;
